export default "__VITE_ASSET__5XBi_sAA__"